// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-game-option-button-container {
  display: flex;
  flex-direction: column;
  margin: 10px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border-color: rgba(113, 132, 153, 0.445);
  border-style: solid;
  border-width: 2px;
  opacity: 0.8;
  max-width: 185px;
  width: 30%;
  min-width: 100px;
}

.create-game-option-button-container.just-icon {
  border: none;
  margin: auto;
}

.create-game-option-button-container:hover {
  background-color: rgba(122, 180, 197, 0.247);
  font-weight: bold;
  opacity: 1;
  border-color: rgba(62, 143, 230, 0.445);
}

.create-game-option-button-img-container {
  width: 80%;
  height: 80%;
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/CreateGames/CreateGameOptionButton/CreateGameOptionButton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,WAAW;AACb","sourcesContent":[".create-game-option-button-container {\n  display: flex;\n  flex-direction: column;\n  margin: 10px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 3px;\n  border-color: rgba(113, 132, 153, 0.445);\n  border-style: solid;\n  border-width: 2px;\n  opacity: 0.8;\n  max-width: 185px;\n  width: 30%;\n  min-width: 100px;\n}\n\n.create-game-option-button-container.just-icon {\n  border: none;\n  margin: auto;\n}\n\n.create-game-option-button-container:hover {\n  background-color: rgba(122, 180, 197, 0.247);\n  font-weight: bold;\n  opacity: 1;\n  border-color: rgba(62, 143, 230, 0.445);\n}\n\n.create-game-option-button-img-container {\n  width: 80%;\n  height: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
